import { Suggestion, GroupedSuggestions, LocationSuggestionsParams } from '@borg/types';

class LocationsService {
  search = (query: string) => serviceHttpGetFactory<Suggestion[]>('/locations', { search: query });
  getSuggestions = (params?: LocationSuggestionsParams) =>
    serviceHttpGetFactory<GroupedSuggestions>('/suggestions/locations', params);
}

export const locationsService = new LocationsService();
